export default "__VITE_ASSET__BngkfvdO__"